import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SelectModule } from '@cmps/ng-select';
import {
    CmpsButtonGroupModule,
    CmpsButtonModule,
    CmpsDialogModule,
    CmpsIconModule,
    CmpsRadioModule,
    CmpsTooltipModule,
    CmpsUserInfoModule,
} from '@cmps/ng-uikit';

import { NextCoachingInsightService } from '../coaching-base/coaching-insight.service';
import { CmpsChartModule } from '../coaching-commitment/chart.module';
import { CmpsCommitmentModule } from '../coaching-commitment/coaching-commitment.module';
import { CmpsObservationModule } from '../coaching-observation/coaching-observation.module';
import { ExperimentalNgGridModule } from '../coaching-observation/experimental.grid';
import { CmpsCoachingWinningPercentageModule } from '../coaching/insight/winning-percentage';
import { CmpsCommonModule } from '../common/common.module';
import { CmpsSingleDecimalPointModule } from '../common/pipe/single-decimal-point';
import { CmpsLazyI18nModule } from '../i18n/i18n.module';
import { CmpsInsightModule } from '../insight/insight.module';
import { CmpsMi2Module } from '../scorecard-mi2/mi2.module';
import { CmpsUserModule } from '../user/user.module';
import { Widgets } from '../widget/widget.model';
import { CmpsWidgetModule } from '../widget/widget.module';

import { TranslationIdMap as coachingInsightTranslationIdMap } from './coaching-insight.i18n';
import { CoachingInsightWidgetComponentNext } from './insight-widget/insight-widget.component';
import { CmpsInsightWidgetModule } from './insight-widget/insight-widget.module';
import { CoachingFilter } from './oa/coaching-filter.component';
import { CoachingInsightWidgetComponent } from './oa/coaching-insight.widget.component';
import { DocumentBlurTriggerDirective } from './oa/document-blur-trigger.directive';
import { ElasticElementDirective } from './oa/elastic-element.directive';
import { ElasticTabsComponent } from './oa/elastic-tabs.component';
import { ForceDropdownPositionDirective } from './oa/force-dropdown-position.directive';
import { FractionBarComponent } from './oa/fraction-bar.component';
import { FrontlineMetricRowComponent } from './oa/frontline/frontline-metric-row.component';
import { FrontlineOAComponent } from './oa/frontline/frontline-oa.component';
import { FrontlinePersonRowComponent } from './oa/frontline/frontline-person-row.component';
import { GoalScoreComponent } from './oa/opportunityalignment/goal-score.component';
import { MetricButtonComponent } from './oa/opportunityalignment/metric-button.component';
import { MetricListComponent } from './oa/opportunityalignment/metric-list.component';
import { OALegendComponent } from './oa/opportunityalignment/oa-legend.component';
import { PersonListComponent } from './oa/opportunityalignment/person-list.component';
import { PersonRowComponent } from './oa/opportunityalignment/person-row.component';
import { TeamOAMetricsComponent } from './oa/opportunityalignment/team-oa-metrics.component';
import { TeamViewTabsComponent } from './oa/opportunityalignment/team-view-tabs.component';
import { CoachingInsightWidgetService } from './oa/services/coaching-insight.widget.service';
import { ElasticUIService } from './oa/services/elastic-ui.service';
import { FrontlineOAService } from './oa/services/frontline-oa.service';
import { PersonOfInterestService } from './oa/services/person-of-interest.service';
import { TeamOAService } from './oa/services/team-oa.service';
import { StickyHeaderDirective } from './stickyheader/stickyheader.directive';

export const OldOaWidgetTypeId = 22;

const ModuleWidgets: Widgets = [
    {
        typeId: 25,
        component: CoachingInsightWidgetComponentNext,
        noEncapsulate: true,
    },
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        SelectModule,

        CmpsLazyI18nModule.forChild(coachingInsightTranslationIdMap),
        CmpsCommonModule,
        CmpsWidgetModule.forChild(ModuleWidgets),
        CmpsUserModule,
        CmpsInsightModule,
        CmpsObservationModule,
        CmpsCommitmentModule,
        CmpsChartModule,
        ExperimentalNgGridModule,
        CmpsUserInfoModule,
        CmpsMi2Module,
        CmpsIconModule,
        CmpsButtonModule,
        CmpsRadioModule,
        CmpsCoachingWinningPercentageModule,
        CmpsButtonGroupModule,
        CmpsTooltipModule,
        CmpsDialogModule,
        CmpsInsightWidgetModule,
        CmpsSingleDecimalPointModule,
    ],
    declarations: [
        CoachingInsightWidgetComponent,
        CoachingInsightWidgetComponentNext,

        CoachingFilter,

        TeamOAMetricsComponent,
        TeamViewTabsComponent,

        PersonRowComponent,

        FrontlineOAComponent,
        FrontlinePersonRowComponent,
        FrontlineMetricRowComponent,
        FractionBarComponent,

        ElasticTabsComponent,
        ElasticElementDirective,
        ForceDropdownPositionDirective,

        PersonListComponent,

        OALegendComponent,

        MetricButtonComponent,
        MetricListComponent,
        GoalScoreComponent,
        StickyHeaderDirective,
        DocumentBlurTriggerDirective,
    ],
    exports: [CoachingInsightWidgetComponentNext],
})
export class CmpsCoachingInsightModule {
    static forRoot(): ModuleWithProviders<CmpsCoachingInsightModule> {
        return {
            ngModule: CmpsCoachingInsightModule,
            providers: [
                CoachingInsightWidgetService,
                NextCoachingInsightService,
                TeamOAService,
                FrontlineOAService,
                PersonOfInterestService,
                ElasticUIService,
            ],
        };
    }
}
